import React from 'react';
import cn from 'classnames';
import Countdown from "../../../ui/Countdown";
import MetaText from "../../../ui/Typography/texts/MetaText";
import styles from './RewardExpirationTime.module.scss';
const RewardExpirationTime = ({ isOfferActive, activeOfferExpiresAt, isValidUntilEnable, personalizedExpireDateFormatted, validUntilText, countdownTranslatedText = '', className, }) => {
    if (isOfferActive) {
        return (React.createElement(Countdown, { expiresAt: activeOfferExpiresAt, className: cn(className, styles.countdown), countdownTranslatedText: countdownTranslatedText, showMinutes: true, showSeconds: true, WrapperTag: "span" }));
    }
    if (isValidUntilEnable) {
        return (React.createElement(MetaText, { Tag: "time", dateTime: personalizedExpireDateFormatted, className: styles.metaTextColor }, validUntilText));
    }
    return null;
};
export default RewardExpirationTime;
//# sourceMappingURL=RewardExpirationTime.js.map